import styled from 'styled-components'

export const BatchModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: calc(85vh - 3rem);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.25rem;
`

export const BatchFieldsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  column-gap: 1rem;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const BatchModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;
  flex-shrink: 0;
`
